import { HttpErrorResponse } from "@angular/common/http";
import {inject, Injectable} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import {SecureStorageService} from "../modules/core/services/secure-storage.service";
import {LocalStorageRelatedData} from "../local-storage-related-data.model";

@Injectable({
    providedIn: "root",
})
export class HandleErrorService {
    private secureStorageService = inject(SecureStorageService)
    constructor(private toastrService: ToastrService) {}

    public handleError(error: any): void {
        console.log("Handling error:", error);
        try {
            if (this.isChunkLoadError(error)) {
                const reloads = this.secureStorageService.getSessionItem<string>(LocalStorageRelatedData.SessionStorage.RC) || "0";
                const reloadCount = parseInt(reloads, 10);

                if (reloadCount >= 3) {
                    // Notify the user and log the issue
                    this.toastrService.error(
                        "The application is having issues loading new updates. Please check your network or contact support.",
                        "Error",
                    );
                    console.error("Multiple reload attempts failed. Please check server and deployment.");
                    this.secureStorageService.setSessionItem(LocalStorageRelatedData.SessionStorage.RC, "0");
                    return;
                }

                // Update the reload count and notify the user
                this.secureStorageService.setSessionItem(LocalStorageRelatedData.SessionStorage.RC, String(reloadCount + 1));
                this.toastrService.error("New updates are available, reloading to update...", "Update");

                // Use setTimeout to reload the page
                setTimeout(() => window.location.reload(), 1000);
                return;
            }
        } catch (e) {
            console.error("Error handling chunk load error", e);
        }

        // Handle other errors
        const message = this.extractErrorMessage(error);
        this.toastrService.error(message, "Error");
    }

    public extractErrorMessage(error: any): string {
        // Default error message
        let message = "An unexpected error occurred. Please try again.";

        // Handling client-side errors
        if (error instanceof ErrorEvent) {
            message = error?.message || message;
        }
        // Handling HttpErrorResponse errors
        else if (error instanceof HttpErrorResponse) {
            message = error?.error?.message || error?.message || message;
        }
        // Handling generic JS errors
        else if (error instanceof Error) {
            message = error?.message || message;
        } else if (typeof error === "string" && error?.length > 0 ) {
            message = error; // Custom error message
        }
        return message;
    }

    private isChunkLoadError(error: any): boolean {
        return error?.message && error?.message?.includes("Loading chunk") && error?.message?.includes("failed");
    }
}
